import React, {Component, ReactElement} from 'react';
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet
} from '../../../components/shared/hoc/createResidentWithErrorHandlingPage';
import {Nullable} from '../../../app/TypeHelpers';
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants';
import styled from 'styled-components'
import {
    FlexContainer,
    FullWidthColumnFlexContainer,
} from '../../../styledComponents/FlexComponents'
import moment from 'moment';
import {StyledSecondaryButton} from '../../../styledComponents/Button';
import {NatDisasterModeSettingLocationState, ModeSettingType} from './common/NatDisasterModeSettingLocationState'
import {ImgCompleteIcon} from "../../common/icons/NatSvgIcon";
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string,
    location: Location<NatDisasterModeSettingLocationState>,
}

interface State {
}

class NatResidentDisasterModeSetupCompletePage
    extends Component<Props & ResidentWithErrorHandlingPagePropsSet, State> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        if (!this.props.location.state) {
            window.location.href =`/resident/error`
            return;
        }
        this.backButtonClick = this.backButtonClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
    }

    // 災害時モードラベル
    renderDisasterModeLabel(): Nullable<ReactElement> {
        if (!this.props.location.state.disasterEndDate || this.props.location.state.modeSettingType === 'release') {
            return (<></>);
        }
        return (
            <DisasterModeLabel>
                <DisasterModeLabelTextBlock>
                    <DisasterModeLabelText>
                        災害時モード
                    </DisasterModeLabelText>
                    <DisasterModeLabelDateText>
                        {moment(this.props.location.state.disasterEndDate).format('YYYY年M月D日(ddd)') + 'まで'}
                    </DisasterModeLabelDateText>
                </DisasterModeLabelTextBlock>
            </DisasterModeLabel>
        )
    }

    // モード別表示アイコン取得
    getModeIcon(modeType: ModeSettingType): Nullable<ReactElement> {
        // モード分岐
        if (modeType === 'release') {
            // 解除の場合
            return <ImgCompleteIcon/>
        }
        // 設定・延長の場合
        return <ImgCompleteIcon
            color={Colors.Disaster}
        />
    }

    // モード別文言取得
    getModeText(modeType: ModeSettingType): string {
        // モード分岐
        switch (modeType) {
            case 'setting':
                return 'に設定';
            case 'release':
                return 'を解除';
            case 'extension':
                return 'を延長';
            default:
                return '';
        }
    }

    // 戻るボタン
    backButtonClick(): void {
        const {navigate, condominiumCd} = this.props
        navigate(`/resident/condominiums/${condominiumCd}/disasters/prevention/top`, {replace: true});
    }


    // 完了アイコンと文言を描画
    renderComplete(): Nullable<ReactElement> {
        return (<>
            <FullWidthColumnFlexContainer>
                <ImageBlock>
                    {this.getModeIcon(this.props.location.state.modeSettingType)}
                    <BlockSpacer height={'5px'}/>
                </ImageBlock>
                <BlockSpacer height={'20px'}/>
                <MainTextBlock>
                    災害時モード{this.getModeText(this.props.location.state.modeSettingType)}しました
                </MainTextBlock>
                <BlockSpacer height={'30px'}/>
            </FullWidthColumnFlexContainer>
        </>)
    }

    // 防災たすけあいへ戻るボタンの表示
    renderBackButton(): Nullable<ReactElement> {
        return (<>
            <SubContainer>
                <ButtonContainer>
                    <BlockSpacer height={'30px'}/>
                    <StyledSecondaryButton onClick={this.backButtonClick}>
                        防災たすけあいへ戻る
                    </StyledSecondaryButton>
                    <BlockSpacer height={'30px'}/>
                </ButtonContainer>
            </SubContainer>
        </>)
    }

    render(): Nullable<ReactElement> {
        return (<>
            {this.renderDisasterModeLabel()}
            <BlockSpacer height={'75px'}/>
            {this.renderComplete()}
            {this.renderBackButton()}
        </>)
    }
}

export default createResidentWithErrorHandlingPage(NatResidentDisasterModeSetupCompletePage)

const DisasterModeLabel = styled.div`
    position: relative;
    width: calc(100% + 30px);
    margin-left: -15px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${Colors.Disaster};
`
const DisasterModeLabelTextBlock = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 15px;
    gap: 10px
`
const DisasterModeLabelText = styled.span`
    font-weight: ${FontWeights.Bold};
    font-size: ${FontSize.Body};
    color: ${Colors.Surface};
    line-height: 24px;
`
const DisasterModeLabelDateText = styled.span`
    font-weight: ${FontWeights.Bold};
    font-size: ${FontSize.Body};
    color: ${Colors.Surface};
    line-height: 24px;
`

const ImageBlock = styled.div`
    width: 345px;
    height: 125px;
    text-align: center;
`
const MainTextBlock = styled.div`
    width: 100%;
    height: 36px;
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    color: ${Colors.AccentDark};
`

const SubContainer = styled(FullWidthColumnFlexContainer)`
    width: 100%;
    height: 110px;
`
const ButtonContainer = styled(FlexContainer)`
    width: 345px;
    height: 50px;
    margin: auto;
`